import { render, staticRenderFns } from "./MenuOptions.vue?vue&type=template&id=393a347e&scoped=true"
import script from "./MenuOptions.vue?vue&type=script&lang=js"
export * from "./MenuOptions.vue?vue&type=script&lang=js"
import style0 from "./MenuOptions.vue?vue&type=style&index=0&id=393a347e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393a347e",
  null
  
)

export default component.exports